import React, {useRef, useState} from 'react';
import { connect } from 'react-redux';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { FindInPage, AddToPhotos } from '@material-ui/icons';
import { Redirect } from 'react-router-dom';
import { hasPermission, createHistory, hasAtLeastOnePermission } from '../../sc-utilities';
import RoleList from './RoleList';
import { isSuperUser } from '../../sc-utilities';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    }
});

const Role = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;

    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, roleID: null, redirectPath: '' });
    const redirectHandler = (path, roleID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, roleID: roleID, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    let visible = columns && columns['Role'];
    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {
                    hasPermission(permissions, 'role_load') ? <Tooltip title={translations["role_details"] || "Role details"}>
                        <IconButton
                            id={`edit_role_${rowData.RoleID}`}
                            component='div'
                            onClick={(event) => redirectHandler(`/roles/edit?roleID=${rowData.RoleID}`)}
                        >
                            <FindInPage />
                        </IconButton>
                    </Tooltip>
                        : null
                }

{
                    hasPermission(permissions, 'role_create') ? <Tooltip title={translations["create_from_this"] || "Create from this"}>
                        <IconButton
                            id={`copy_role_${rowData.RoleID}`}
                            component='div'
                            onClick={() => redirectHandler(`/roles/edit?roleID=${rowData.RoleID}&copy=true`)}
                        >
                            <AddToPhotos />
                        </IconButton>
                    </Tooltip>
                        : null
                }
            </>
        },
        {
            title: translations["name"] || 'Name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["fancy_name"] || 'Fancy name', field: 'FancyName',
            hidden: visible ? visible['FancyName'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.FancyName ? rowData.FancyName : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["type"] || 'Type', field: 'Type',
            hidden: visible ? visible['Type'] : false,
            filtering: isSuperUser(),
            lookup: { 'public': translations['public'] || 'Public', 'private': translations['private'] || 'Private' },
            defaultFilter: isSuperUser() ? ['private', 'public'] : ['public'],
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Type && rowData.Type === 'public' ? translations['public'] || 'Public' : rowData.Type && rowData.Type === 'private' ? translations['private'] || 'Private' : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["module"] || 'Module', field: 'Module',
            hidden: visible ? visible['Module'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Module ? rowData.Module : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["locked"] || 'Locked', field: 'Locked',
            hidden: visible ? visible['Locked'] : false,
            filtering: true,
            lookup: { '1': translations['yes'] || 'Yes', '0': translations['no'] || 'No' },
            defaultFilter: ['0', '1'],
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Locked ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
            }
        }
    ];

    if (!isSuperUser()) {
        tableColumns = tableColumns.filter(column => column.field !== 'Type');
    }

    if (!hasAtLeastOnePermission(permissions, ['role_load'])) {
        tableColumns.shift();
    };

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'role_list') ?
                <RoleList
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(Role));